import React, { lazy, Suspense } from "react";
import { Link } from "react-router-dom";
import { m } from "motion/react";
import { AiFillGithub } from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";
import { HiArrowUpRight } from "react-icons/hi2";
import myImg from "../../Assets/sep.png";
import { Reveal, TiltSurface } from "./MotionPrimitives";
const Github = lazy(() => import("../About/Github"));

export default function Home2({ still }) {
  return (
    <section
      id="home-about"
      className="home-about home-shell"
      aria-labelledby="home-about-title"
    >
      <Reveal className="home-about-heading">
        <div className="home-eyebrow">
          <span className="home-index">02</span> ABOUT ME{" "}
          <span className="home-hairline" />
        </div>
        <h2 id="home-about-title">
          Let me <span>introduce</span>
          <br />
          myself<span className="home-heading-period">.</span>
        </h2>
      </Reveal>
      <div className="home-about-layout">
        <Reveal className="home-portrait-column">
          <TiltSurface still={still} className="home-portrait">
            <div className="home-portrait-top">
              <span>THE HUMAN BEHIND THE CODE</span>
              <span aria-hidden="true">↗</span>
            </div>
            <div className="home-portrait-image">
              <img
                src={myImg}
                alt="Illustrated portrait of Sep Aminian"
                width="697"
                height="570"
                loading="lazy"
              />
              <span className="home-portrait-sticker" aria-hidden="true">
                &lt;/&gt;
              </span>
            </div>
            <div className="home-portrait-bottom">
              <strong>Sep Aminian</strong>
              <span>London, UK</span>
            </div>
          </TiltSurface>
          <div className="home-socials">
            <m.a
              href="https://github.com/sephml"
              target="_blank"
              rel="noopener noreferrer"
              whileHover={{ y: -3 }}
            >
              <AiFillGithub /> GitHub <HiArrowUpRight />
            </m.a>
            <m.a
              href="https://www.linkedin.com/in/amirsepehr-aminian/"
              target="_blank"
              rel="noopener noreferrer"
              whileHover={{ y: -3 }}
            >
              <FaLinkedinIn /> LinkedIn <HiArrowUpRight />
            </m.a>
          </div>
        </Reveal>
        <div className="home-bio">
          <Reveal className="home-bio-card" delay={0.08}>
            <span className="home-bio-number">01 / THE WORK</span>
            <p>
              I'm passionate about building intelligent systems that solve
              real-world problems. With expertise in{" "}
              <strong>Large Language Models</strong> and deep learning, I
              transform cutting-edge AI research into production-ready
              solutions.
            </p>
            <div className="home-bio-tags">
              <span>Large Language Models</span>
              <span>Deep Learning</span>
            </div>
          </Reveal>
          <Reveal className="home-bio-card" delay={0.12}>
            <span className="home-bio-number">02 / THE TOOLKIT</span>
            <p>
              Fluent in <strong>Python, C++, and JavaScript</strong>, with a
              strong foundation in modern ML/AI frameworks - PyTorch,
              TensorFlow, and the broader HuggingFace ecosystem.
            </p>
            <div className="home-bio-tags">
              <span>Python</span>
              <span>C++</span>
              <span>JavaScript</span>
            </div>
          </Reveal>
          <Reveal className="home-bio-card home-bio-personal" delay={0.16}>
            <span className="home-bio-number">03 / OFFLINE</span>
            <p>
              Beyond coding, I enjoy <strong>exploring startup ideas</strong>,
              travelling, and gaming to stay creative.
            </p>
            <span className="home-personal-symbol" aria-hidden="true">
              ✳
            </span>
          </Reveal>
        </div>
      </div>
      <section className="home-github-section" aria-label="GitHub contribution activity">
        <Suspense fallback={<div className="github-panel portfolio-panel" role="status">Loading GitHub activity…</div>}>
          <Github />
        </Suspense>
      </section>
      <Reveal className="home-next">
        <span>EXPLORE THE WORK</span>
        <Link to="/project">
          View Work <HiArrowUpRight />
        </Link>
      </Reveal>
    </section>
  );
}
